import * as APIBase from './APIBase';

const API_INFO_ENV = process.env.REACT_APP_APP_INFO_ENV;
const API_INFO_PREFIX = process.env.REACT_APP_API_APP_INFO_PREFIX;
const API_INFO_QUERY = process.env.REACT_APP_API_APP_INFO_QUERY;
const API_INFO_KEY_DEFAULT = process.env.REACT_APP_API_APP_INFO_KEY_DEFAULT;
const API_INFO_KEY_TMNA = process.env.REACT_APP_API_APP_INFO_KEY_TMNA;
const API_INFO_KEY_DENSO = process.env.REACT_APP_API_APP_INFO_KEY_DENSO;
const API_INFO_KEY_PANA = process.env.REACT_APP_API_APP_INFO_KEY_PANA;

export default class AppInfoAPI {
  static get({supplier}) {
    let key = '';
    switch (supplier) {
      case 'tmna':
        key = API_INFO_KEY_TMNA;
        break;
      case 'densoten':
        key = API_INFO_KEY_DENSO;
        break;
      case 'panasonic':
        key = API_INFO_KEY_PANA;
        break;
      default:
        key = API_INFO_KEY_DEFAULT;
    }
    return APIBase.getAPI(`${API_INFO_PREFIX}${API_INFO_ENV}${API_INFO_QUERY}${supplier}`, {
      'x-api-key': key,
    });
  }
}
